import React from "react";
import moment from 'moment';
import 'moment/locale/vi';

// set moment globally
moment.locale("vi");

const TimeFromNow = ({ value }) => {
  const utcTime = moment.utc(value, "YYYY-MM-DD HH:mm:ss")
  const localTime = utcTime.local()
  return <span>{moment(localTime, "YYYY-MM-DD HH:mm:ss").fromNow()}</span>;
};

export const TimeFormat = ({ value }) => {
  const utcTime = moment.utc(value, "YYYY-MM-DD HH:mm:ss")
  const localTime = utcTime.local()
  return <span>{moment(localTime, "YYYY-MM-DD HH:mm:ss")}</span>;
};

export default TimeFromNow;
